import { render, staticRenderFns } from "./FareDetails.vue?vue&type=template&id=04899dd2&"
import script from "./FareDetails.vue?vue&type=script&lang=js&"
export * from "./FareDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports